module.exports = __webpack_public_path__ + "static/media/howItWorks_2.44217631.svg";